import { useMemo } from 'react';
import { useWhatsAppChats } from './useWhatsAppChats';
import { WhatsAppChatSource, WhatsAppSurface } from './types';

/**
 * The single hook the Portfolio surface provider composes. Returns `undefined`
 * when disabled, in which case NO babler call is ever made: every network call starts from
 * `onOrbOpen` / `open`, which only exist on the enabled surface.
 */
export const useWhatsAppSurface = ({ enabled, source }: { enabled: boolean; source?: WhatsAppChatSource }): WhatsAppSurface | undefined => {
    const { chats, activeChatId, items, hasMore, isLoading, isLoadingOlder, hasError, olderError, loadChats, open, loadOlder, close } =
        useWhatsAppChats(source);

    return useMemo(
        () =>
            enabled
                ? {
                      chats,
                      isOpen: activeChatId !== null,
                      activeChatId,
                      items,
                      hasMore,
                      isLoading,
                      isLoadingOlder,
                      hasError,
                      olderError,
                      open,
                      loadOlder,
                      close,
                      onOrbOpen: loadChats,
                  }
                : undefined,
        [enabled, chats, activeChatId, items, hasMore, isLoading, isLoadingOlder, hasError, olderError, open, loadOlder, close, loadChats],
    );
};
